import type { InkStroke } from '../components/gn/blocks/InkBlockNode';

/**
 * Renders captured ink strokes to a PNG data URI for interpretation/cue-classification
 * requests (spec 046 research Decision 4) — the multimodal LLM reads a rasterized image,
 * not raw stroke coordinates.
 */
export function rasterizeInk(strokes: InkStroke[], width: number, height: number): string {
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext('2d');
  if (!ctx) return '';

  ctx.fillStyle = '#ffffff';
  ctx.fillRect(0, 0, width, height);
  ctx.strokeStyle = '#000000';
  ctx.lineWidth = 2;
  ctx.lineCap = 'round';
  ctx.lineJoin = 'round';

  for (const stroke of strokes) {
    const points = stroke.points;
    if (points.length < 4) continue;
    ctx.beginPath();
    ctx.moveTo(points[0], points[1]);
    for (let i = 2; i < points.length; i += 2) {
      ctx.lineTo(points[i], points[i + 1]);
    }
    ctx.stroke();
  }

  return canvas.toDataURL('image/png');
}

/** Strips the `data:image/png;base64,` prefix for API payloads that want raw base64. */
export function toBase64Payload(dataUrl: string): string {
  const comma = dataUrl.indexOf(',');
  return comma === -1 ? dataUrl : dataUrl.slice(comma + 1);
}
